import type { NavigationSection, RoleSlug } from './types';

export const AUTHENTICATED_ROLES: readonly RoleSlug[] = [
	'admin',
	'editor',
	'investigador',
];
export const ADMIN_EDITOR_ROLES: readonly RoleSlug[] = ['admin', 'editor'];
export const ADMIN_ONLY_ROLES: readonly RoleSlug[] = ['admin'];

/**
 * Orden vertical de los módulos de /admin, para la dirección de la animación de
 * página: se lee como una continuación del sidebar (todos cuelgan de
 * "Administración"). Debe reflejar el orden en que `AdminModulesGrid` pinta sus
 * cards; un módulo que falte acá no rompe nada, solo cae al fallback de la
 * transición.
 */
export const ADMIN_NAVIGATION_ORDER: readonly string[] = [
	'/admin/alertas',
	'/admin/solicitudes',
	'/admin/auditoria',
	'/admin/automatizaciones',
	'/admin/configuraciones',
	'/admin/investigadores',
	'/admin/correos',
	'/admin/toasts',
	'/admin/eventos',
	'/admin/publicaciones',
	'/admin/proyectos',
	'/admin/lineas',
	'/admin/revalidaciones',
	'/admin/parametros',
];

/**
 * Destinos del pie del sidebar. Van al final de la pila de menús porque eso es lo
 * que ve el usuario: están abajo de todo, así que ir al perfil siempre "baja".
 */
export const FOOTER_NAVIGATION_ORDER: readonly string[] = ['/mi-perfil', '/configuracion'];

export const MAIN_NAVIGATION: NavigationSection[] = [
	{
		id: 'portal',
		title: 'Portal',
		items: [
			{
				label: 'Inicio',
				href: '/',
				icon: 'home',
				description: 'Resumen institucional y convocatorias',
			},
			{
				label: 'Publicaciones',
				href: '/publicaciones',
				icon: 'file',
				description: 'Producción científica con acceso abierto',
				// First release ships without these modules; keep them admin-only
				// until they are built.
				allowedRoles: ADMIN_ONLY_ROLES,
			},
			{
				label: 'Proyectos',
				href: '/proyectos',
				icon: 'layers',
				description: 'Portafolio activo de investigación',
				allowedRoles: ADMIN_ONLY_ROLES,
			},
			{
				label: 'Investigadores',
				href: '/investigadores',
				icon: 'users',
				description: 'Directorio y líneas de investigación',
			},
			{
				label: 'Gráficos',
				href: '/graficos',
				icon: 'chart',
				description: 'Tableros y series sobre la producción institucional',
				// En construcción: sólo admin hasta que la vista tenga contenido.
				allowedRoles: ADMIN_ONLY_ROLES,
			},
			{
				label: 'Líneas de Investigación',
				href: '/lineas',
				icon: 'graduation-cap',
				description: 'Áreas de trabajo y estudio',
				allowedRoles: ADMIN_ONLY_ROLES,
			},
		],
	},
	{
		id: 'panel',
		title: 'Panel Interno',
		items: [
			/* {
				label: 'Revisiones',
				href: '/revisiones',
				icon: 'clipboard-check',
				description: 'Bandeja exclusiva de editores',
				allowedRoles: ADMIN_EDITOR_ROLES,
			}, */
			/* {
				label: 'Gestión editorial',
				href: '/editor',
				icon: 'file-check',
				description: 'Operación de validación y flujos',
				allowedRoles: ADMIN_EDITOR_ROLES,
			}, */
			{
				label: 'Administración',
				href: '/admin',
				icon: 'shield-check',
				description: 'Módulos administrativos del sistema',
				allowedRoles: ADMIN_ONLY_ROLES,
			},
		],
	},
];
